import { AggregationLevel } from './Energy';
//*** Miscellaneous ***//
export const TimeSeriesAggregationLevel = {
    [AggregationLevel.ONE_DAY]: '1d',
    [AggregationLevel.ONE_MINUTE]: '1m',
    [AggregationLevel.FIFTEEN_MINUTE]: '15m',
    [AggregationLevel.ONE_HOUR]: '1h',
};
